import React, { useState, useRef } from 'react';
import StoreLocations from './locations';
import { useSelector, useDispatch } from 'react-redux';
import useSupercluster from "use-supercluster";
import GoogleMapReact from "google-map-react";
import { googlemapcenteraction, InfoBoxAction, MapZoomAction } from './actions';
import useGeoLocation from './Currentlocation';
import { geocodeByAddress } from 'react-places-autocomplete';
import Autocomplete from 'react-google-autocomplete';
import InfoIconData from './InfoIconData';
import * as geolib from 'geolib';
const Marker = ({ children }) => children;
var MMap = ( props ) => {
    var SiteData = useSelector(state => state.SiteData);
    var dispatch = useDispatch();
    const handleClickOpen = ( data ) => {
        for ( let element of document.getElementsByClassName('rslInfobox') ) {
            element.style.display="none";
        }
        var id = `infobox_${data.id}`;
        dispatch(MapZoomAction(20));
        dispatch(InfoBoxAction(data));
        dispatch(googlemapcenteraction( { init: false, coordinates: { lat: parseFloat(data.metadata.latitude), lng: parseFloat(data.metadata.longitude) } } ));
        if ( null !== document.getElementById(id) ) {
            document.getElementById(id).style.display = "block";
        }
    };
    StoreLocations();
    const mapRef = useRef();
    const [bounds, setBounds] = useState(null);
    const LocationsData = useSelector(state => state.StoreLocations);
    const zoom = useSelector(state => state.MapZoomValue);
    const Locations = LocationsData.data;
    var points = [];
    var isyes = false;
    var latitude = 0;
    var longitude = 0;
    var coorinatesData = useSelector(state => state.MapCenterPoint)
    var center = coorinatesData.coordinates;
    var dlatitude = SiteData.dlatitude ? parseFloat(SiteData.dlatitude) : 48.8584;
    var dlongitude = SiteData.dlongitude ? parseFloat(SiteData.dlongitude) : 2.2945;
    if ( !geolib.isValidCoordinate({ latitude: dlatitude, longitude: dlongitude }) ) {
        dlatitude = 0;
        dlongitude = 0;
    }
    if ( 0 === center.lng ) {
        center = {lat:dlatitude, lng: dlongitude};
    }
    const radius = useSelector(state => state.MadRadius);
    if ( undefined !== Locations ) {
        points = Locations.map(location => {
            longitude = parseFloat(location.metadata.longitude);
            latitude = parseFloat(location.metadata.latitude);
            isyes = geolib.isPointWithinRadius(
                { latitude: latitude, longitude: longitude },
                { latitude: center.lat, longitude: center.lng },//current
                radius
            );
            if ( !isyes ) {
                return true;
            }
            return {type: "Feature",
            properties: { cluster: false, id: location.id, icon: location.metadata.icon_url, location:location },
            geometry: { type: "Point", coordinates: [ longitude, latitude ]}}
        });
    }
    const { clusters, supercluster } = useSupercluster({ points, bounds, zoom, options: { radius: 75, maxZoom: 20 } });
    useGeoLocation();
    var counter = 0;
    var styles = '';
    try {
        styles = JSON.parse(SiteData.map_style);
     } catch ( e ) {
        styles = false;
     }
    var map_type = SiteData.map_type ? SiteData.map_type : 'roadmap';
    var streetviewcontrol = SiteData.streetviewcontrol ? true : false;
    var maptypecontrol = SiteData.maptypecontrol ? true : false;
    var zoomcontrol = SiteData.zoomcontrol ? true : false;
    var fullscreencontrol = SiteData.fullscreencontrol ? true : false;
    return (
        <div className="rsl_googlemap">
            <GoogleMapReact center={center} zoom={zoom} mapContainerStyle={{ width: '100%', height: '100%' }}
            options={{ styles: styles, mapTypeId: map_type, zoomControl: zoomcontrol, streetViewControl: streetviewcontrol, mapTypeControl: maptypecontrol, fullscreenControl: fullscreencontrol }}
            defaultZoom={10} yesIWantToUseGoogleMapApiInternals 
            onGoogleApiLoaded={({ map }) => { mapRef.current = map; }}
            onChange={({ zoom, bounds }) => { dispatch(MapZoomAction(zoom)); setBounds([ bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat ]); }} >
            {
            clusters.map(cluster => {
            counter++;
            const [longitude, latitude] = cluster.geometry.coordinates;
            const { cluster: isCluster, icon:markerIcon, point_count: pointCount, location:location } = cluster.properties;
            if ( isCluster ) {
                return (
                    <Marker key={`cluster-${cluster.id}`} lat={latitude} lng={longitude}>
                        <div className={`cluster-marker cluster-marker${counter}`}
                            style={{
                            width: `${10 + (pointCount / points.length) * 20}px`,
                            height: `${10 + (pointCount / points.length) * 20}px`
                            }} onClick={() => {
                            const expansionZoom = Math.min( supercluster.getClusterExpansionZoom(cluster.id), 20 );
                            mapRef.current.setZoom(expansionZoom);
                            mapRef.current.panTo({ lat: latitude, lng: longitude }); }}>
                            {pointCount}
                        </div>
                    </Marker>
                );
            }
            var id = `infobox_${cluster.properties.id}`;
            return (
                <Marker key={`gmap-${cluster.properties.id}`} lat={latitude} lng={longitude}>
                    <div style={{position:'relative'}}>
                        <div className="rslInfobox" id={id}><InfoIconData /></div>
                        <img src={markerIcon} alt="marker" width={50} onClick={() => handleClickOpen(location) } className="markerimg" />
                    </div>
                </Marker>
            );
        })}
            </GoogleMapReact>
        </div>
    );
}
export const GAutoComplete = () => {
    var dispatch = useDispatch()
    const findstores = async (address) => {
        address = address.formatted_address
        geocodeByAddress(address).then(results => {
            dispatch(googlemapcenteraction({ init: true, coordinates: { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() } }))
        }).catch(error => console.error('Error', error));
    }
    var SiteData = useSelector(state => state.SiteData);
    var restrictcountries = SiteData.restrictcountries ? SiteData.restrictcountries : [];
    var searchtype = SiteData.searchtype ? SiteData.searchtype : 'address';
    return <Autocomplete className="autocompletefields" onPlaceSelected={findstores}  options={{ 
        types: [searchtype], componentRestrictions: { country: restrictcountries } }} />
}
export default MMap;